import {Routes, Route, Outlet} from "react-router-dom";

import {useIsMobile} from "../../../shared/responsive";
import {CreateLand, ViewField} from "./ViewField";
import CreateField from "./CreateField";
import CreateGap from "./ViewField/Gap/CreateGap";
import {ListFields} from "./ListFields";

export const LeftContainerFields = () => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <Routes>
                <Route path='/new' element={<CreateField />} />
                <Route path='/view/:field_id/land/new' element={<CreateLand />} />
                <Route path='/view/:field_id/gap/new' element={<CreateGap />} />
                <Route path="/view/:field_id/*" element={<ViewField />} />
                <Route path="/list" element={<ListFields />} />
            </Routes>
        );
    }

    return (
        <>
            <Routes>
                <Route path='/view/:field_id/land/new' element={<CreateLand />} />
                <Route path="/view/:field_id/gap/new" element={<CreateGap />} />
                <Route path="/view/:field_id/*" element={<ViewField />} />
                <Route path="/list" element={<ListFields />} />
            </Routes>
        </>
    );
};

export const AnyContainerFields = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route path='/new' element={<CreateField />} />
            </Route>
        </Routes>
    );
};
